module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"参加する一覧":"参加する一覧","学ぶ一覧":"学ぶ一覧","コンテンツ":"コンテンツ"},"en":{"参加する一覧":"Events","学ぶ一覧":"Library","コンテンツ":"Article"}}')
  delete Component.options._Ctor
}
